<script setup lang="ts">
import { Edit, Eye, Trash2 } from 'lucide-vue-next';
import { computed } from 'vue';

export interface ActionButtonProps {
  disabled?: boolean;
  type: 'delete' | 'details' | 'edit';
}

const props = withDefaults(defineProps<ActionButtonProps>(), {
  disabled: false,
});

const emit = defineEmits<{
  'click': [];
}>();

const config = computed(() => {
  const configs = {
    delete: {
      color: '#dc3545',
      icon: Trash2,
      label: 'Excluir',
      title: 'Excluir',
    },
    details: {
      color: '#0d6efd',
      icon: Eye,
      label: 'Detalhes',
      title: 'Detalhes',
    },
    edit: {
      color: '#ffc107',
      icon: Edit,
      label: 'Editar',
      title: 'Editar',
    },
  };

  return configs[props.type];
});

const handleClick = () => {
  if (!props.disabled) {
    emit('click');
  }
};
</script>

<template>
  <button
    type="button"
    class="action-btn"
    :class="`action-btn--${type}`"
    :title="config.title"
    :aria-label="config.label"
    :disabled="disabled"
    @click="handleClick"
  >
    <component :is="config.icon" class="icon icon-sm" />
  </button>
</template>

<style scoped lang="scss">
.action-btn {
  background-color: transparent;
  border: 1px solid transparent;
  border-radius: 0.375rem;
  padding: 0.375rem;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  transition: border-color 0.15s ease-in-out, background-color 0.15s ease-in-out;
  cursor: pointer;

  &:focus-visible {
    outline: 2px solid #6c757d;
    outline-offset: 2px;
  }

  &:disabled {
    opacity: 0.5;
    cursor: not-allowed;
  }

  .icon {
    width: 24px;
    height: 24px;
  }
}

.action-btn--details {
  .icon {
    stroke: #0d6efd;
  }

  &:hover:not(:disabled) {
    border-color: #0d6efd;
  }
}

.action-btn--edit {
  .icon {
    stroke: #ffc107;
  }

  &:hover:not(:disabled) {
    border-color: #ffc107;
  }
}

.action-btn--delete {
  .icon {
    stroke: #dc3545;
  }

  &:hover:not(:disabled) {
    border-color: #dc3545;
  }
}
</style>
